//todo: temp

import ReferralsHelpContent from '../ui/help/ReferralsHelpContent';
import CardsHelpContent from '../ui/help/CardsHelpContent';
import TeamsHelpContent from '../ui/help/TeamsHelpContent';
import TransactionsHelpContent from '../ui/help/TransactionsHelpContent';
export const helpContent = {
  referrals: {
    title: 'How it works?',
    content: ReferralsHelpContent,
  },
  cards: {
    title: 'How it works?',
    content: CardsHelpContent,
  },
  teams: {
    title: 'How it works?',
    content: TeamsHelpContent,
  },
  transactions: {
    title: 'How it works?',
    content: TransactionsHelpContent,
  },
};
